var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnInit } from '@angular/core';
import { ContactDetailsService } from '../contact-details.service';
import { FormBuilder } from '@angular/forms';
import { NotificationService } from '../../shared/notification.service';
import { HistoryService } from '../contact-history/history.service';
import { ContactsService } from '../../contacts/shared/services/contacts.service';
import { ValidateExternalLink } from './import-details.validators';
var ImportDetailsComponent = /** @class */ (function () {
    function ImportDetailsComponent(fb, contactDetailsService, notificationService, historyService, contactsService) {
        this.fb = fb;
        this.contactDetailsService = contactDetailsService;
        this.notificationService = notificationService;
        this.historyService = historyService;
        this.contactsService = contactsService;
        this.loading = false;
    }
    ImportDetailsComponent.prototype.ngOnInit = function () {
        this.refreshData(this.recordId);
        this.contactsService.setTagEditorPosition({
            top: 0,
            left: 0,
            rowId: this.recordId
        });
        this.initForm(this.contact);
    };
    ImportDetailsComponent.prototype.initForm = function (data) {
        var externalLink = data && data.externalLink ? data.externalLink : '';
        this.detailsForm = this.fb.group({
            firstName: [data && data.firstName ? data.firstName : ''],
            lastName: [data && data.lastName ? data.lastName : ''],
            company: [data && data.company ? data.company : ''],
            email: [data && data.email ? data.email : ''],
            externalLink: [externalLink, ValidateExternalLink()],
        });
    };
    ImportDetailsComponent.prototype.isExternalLinkValid = function () {
        return this.detailsForm.get('externalLink').valid;
    };
    ImportDetailsComponent.prototype.refreshData = function (id) {
        var _this = this;
        this.loading = false;
        this.contactDetailsService.getContactDetails(id).subscribe(function (data) {
            _this.contact = data;
            _this.loading = false;
            _this.initForm(_this.contact);
            _this.hyperLink = _this.contact.externalLink;
        });
    };
    ImportDetailsComponent.prototype.saveChanges = function () {
        var _this = this;
        this.loading = true;
        var formData = {
            firstName: this.detailsForm.get('firstName').value,
            lastName: this.detailsForm.get('lastName').value,
            company: this.detailsForm.get('company').value,
            email: this.detailsForm.get('email').value,
            externalLink: this.detailsForm.get('externalLink').value
        };
        var updatedData = __assign({}, this.importData, formData);
        this.contactDetailsService.saveContactDetails(this.recordId, updatedData).subscribe(function () {
            _this.notificationService.open('EVENT_DETAILS.CHANGED_IMPORTED_DATA');
            _this.historyService.refreshHistory(_this.recordId);
            _this.loading = false;
        }, function (error) {
            _this.notificationService.open(error);
        });
        this.hyperLink = updatedData.externalLink;
    };
    return ImportDetailsComponent;
}());
export { ImportDetailsComponent };
